import React from 'react';
import { cn } from '../utils';
export function Button({
  children,
  className,
  variant = 'primary',
  size = 'lg',
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
}) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-slate-950';
  const variants = {
    primary: 'bg-brand-500 hover:bg-brand-400 text-slate-950 shadow-[0_0_20px_rgba(201,166,106,0.4)] hover:shadow-[0_0_30px_rgba(201,166,106,0.6)] focus:ring-brand-500',
    secondary: 'bg-brand-600 hover:bg-brand-500 text-white shadow-[0_0_20px_rgba(16,185,129,0.4)] hover:shadow-[0_0_30px_rgba(16,185,129,0.6)] focus:ring-brand-500',
    outline: 'border-2 border-brand-500 text-brand-400 hover:bg-brand-500/10 focus:ring-brand-500'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl md:text-2xl'
  };
  return <button className={cn(baseStyles, variants[variant], sizes[size], className)} {...props} data-id="element-277" data-mp="1227gtif2rb4o">
      {children}
    </button>;
}
export function Badge({
  children,
  className,
  variant = 'default'
}: {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'success' | 'warning';
}) {
  const variants = {
    default: 'bg-slate-800 text-slate-300 border border-slate-700',
    success: 'bg-brand-500/10 text-brand-400 border border-brand-500/20',
    warning: 'bg-amber-500/10 text-amber-400 border border-amber-500/20'
  };
  return <span className={cn('inline-flex items-center px-3 py-1 rounded-full text-sm font-medium', variants[variant], className, 'text-[12px] pt-[1px] pb-[1px] pl-[1px] pr-[1px] flex-row items-center justify-center')} data-id="element-278" data-mp="s4uhrqp3waco">
      {children}
    </span>;
}
export function Card({
  children,
  className,
  glow = false
}: {
  children: React.ReactNode;
  className?: string;
  glow?: boolean;
}) {
  return <div className={cn('bg-slate-900 border border-slate-800 rounded-2xl p-6 md:p-8', glow && 'box-glow border-brand-500/30', className)} data-id="element-279" data-mp="y0chhz6kzdv4">
      {children}
    </div>;
}